module.exports = {
  template: 'admin-gra',

  viewerContainerSelector: '#anim_container_intf',

  fieldSelector: 'li[id^="project_"][id$="_input"]',

  viewerIdStyles: {
    project_background_color:                    'background-color',
    project_banner_background_color:             'background-color',
    project_question_background_color:           'background-color',
    project_answer_background_color:             'background-color',
    project_typing_dots_color:                   'dot-bg-color',
    project_input_area_color:                    'background-color',

    project_question_answer_title_color:         'color',
    project_chat_question_title_color:           'color',
    project_question_answer_subtitle_color:      'color',
    project_chat_question_subtitle_color:        'color',
    project_question_answer_textcolor:           'color',
    project_chat_question_text_color:            'color',
    project_chat_answer_text_color:              'color',
    project_chat_answer_title_color:             'color',
    project_chat_answer_subtitle_color:          'color',
    project_link_color:                          'color',
    project_typing_text_color:                   'color',
    project_question_text_color:                 'color',
    project_terms_conditions_link_color:         'color',

    project_question_placeholder_color:          'style-placeholder-color',

    project_main_font_url:                       'font-setting',
    project_title_font_url:                      'font-setting',
    project_font_scale:                          'font-setting',

    project_border_color:                        'border-color',
    project_input_border_color:                  'border-color',

    project_icon_scroll_down_color:              'stroke',
    Intf_IconScrollUp:                           'stroke',
    project_icon_copy_button_color:              'details',

    Intf_CopyButtonTextColor:                    'color',
    Intf_CopyButtonHoverTextColor:               'style-hover-color',
    Intf_CopyButtonIconColor:                    'stroke',
    Intf_CopiedButtonTextColor:                  'style-copied-color',
    Intf_CopiedButtonIconColor:                  'stroke',

    project_icon_send_background_color:          'fill',
    project_icon_send_color:                     'fill',
    project_icon_send_hover_background_color:    'fill',
    project_icon_send_hover_color:               'fill',
    project_icon_input_question_color:           'fill',

    project_icon_answer_text_color:              'fill',
    project_icon_answer_background_color_from:   'stop-color',
    project_icon_answer_background_color_to:     'stop-color',

    project_icon_question_text_color:            'fill',
    project_icon_question_background_color_from: 'stop-color',
    project_icon_question_background_color_to:   'stop-color',

    project_icon_scroll_down_background_color:   'fill',
    Intf_IconScrollUpBackgroundColor:            'fill',

    project_source_button_color:             'background-color',
    project_source_button_text_color:        'color',
    project_source_button_border_color:      'border-color',
    project_source_button_border_radius:     'border-radius-px',
    project_source_button_margin_top_bottom: 'padding-tb-px',
    project_source_button_margin_right_left: 'padding-lr-px',

    Intf_SourceLinkButtonColorHover:       'source-hover-bg',
    Intf_SourceLinkButtonTextColorHover:   'source-hover-text',
    Intf_SourceLinkButtonBorderColorHover: 'source-hover-border',

    // GRA-specific px/transform settings
    project_input_border_radius:                 'border-radius-px',
    project_input_height:                        'input-height-percent',
    project_input_border_width:                  'border-width-px',
    project_base_font_size_input_field:          'font-size-px',
    project_base_font_size_typing_text:          'font-size-px',
    project_base_font_size_title:                'font-size-px',
    project_base_font_size_subtitle:             'font-size-px',
    project_input_field_font_weight:             'font-weight',

    project_icon_input_question_scale:           'transform-scale-translatey',
    project_icon_send_scale:                     'transform-scale-translatey',
    project_icon_send_hover_scale:               'transform-scale-translatey',
    project_icon_answer_scale:                   'transform-scale',
    project_icon_question_scale:                 'transform-scale',

    project_answer_question_block_width:                  'width-percent',
    project_answer_question_block_inside_padding:         'padding-all-px',
    project_answer_question_block_border_radius:          'border-radius-block-px',
    project_answer_block_border_radius_bottom_right:      'border-radius-br-px',
    project_answer_block_border_radius_bottom_left:       'border-radius-bl-px',
    project_question_block_border_radius_bottom_right:    'border-radius-br-px',
    project_question_block_border_radius_bottom_left:     'border-radius-bl-px',

    project_typing_dots_size:           'dot-size-px',
    project_typing_dots_margin_between: 'dot-margin-px',
    project_typing_dots_jump_height:    'typing-jump-height-px',
  },

  textViewerFields: [
    'question_message_title',
    'question_message_subtitle',
    'answer_message_title',
    'answer_message_subtitle',
    'typing_text',
  ],

  viewerValueFields: [
    'main_font_url',
    'title_font_url',
    'font_scale',
    'input_border_radius',
    'input_height',
    'input_border_width',
    'base_font_size_input_field',
    'base_font_size_typing_text',
    'base_font_size_title',
    'base_font_size_subtitle',
    'input_field_font_weight',
    'icon_input_question_scale',
    'icon_send_scale',
    'icon_send_hover_scale',
    'icon_answer_scale',
    'icon_question_scale',
    'answer_question_block_width',
    'answer_question_block_inside_padding',
    'answer_question_block_border_radius',
    'answer_block_border_radius_bottom_right',
    'answer_block_border_radius_bottom_left',
    'question_block_border_radius_bottom_right',
    'question_block_border_radius_bottom_left',
    'source_button_border_radius',
    'source_button_margin_top_bottom',
    'source_button_margin_right_left',
    // handled later:
    'typing_dots_size',
    'typing_dots_margin_between',
    'typing_dots_jump_height',
  ],

  tabs: [
    { id: '#branding', default: true },
    { id: '#widget-settings', settings: [
      'project_copy',
      'project_question_placeholder_text',
      'project_question_message_title', 'project_question_message_subtitle',
      'project_answer_message_title', 'project_answer_message_subtitle',
      'project_typing_text',
      'project_typing_label_position',
      'project_first_message_text',
      'project_first_message_title',
      'project_first_message_subtitle',
    ]},
  ],

  scrollPositions: {
    // First message block only → scroll to top
    project_first_message_text:       0,
    project_first_message_title:      0,
    project_first_message_subtitle:   0,

    // Answer block (shared settings → answer wins → bottom)
    project_answer_background_color:                   500,
    project_answer_question_block_inside_padding:      500,
    project_answer_question_block_width:               500,
    project_answer_question_block_border_radius:       500,
    project_answer_block_border_radius_bottom_right:   500,
    project_answer_block_border_radius_bottom_left:    500,
    project_copy:                                      500,
    project_icon_answer_no_display:                    500,
    project_answer_icon:                               500,
    project_icon_answer_scale:                         500,
    project_icon_answer_background_color_from:         500,
    project_icon_answer_background_color_to:           500,
    project_icon_answer_text_color:                    500,
    project_question_answer_title_color:               500,
    project_chat_answer_title_color:                   500,
    project_question_answer_subtitle_color:            500,
    project_chat_answer_subtitle_color:                500,
    project_answer_message_title:                      500,
    project_answer_message_subtitle:                   500,
    project_chat_answer_text_color:                    500,
    project_question_answer_textcolor:                 500,
    project_link_color:                                500,
    project_source_button_color:                       500,
    project_source_button_text_color:                  500,
    project_source_button_border_color:                500,
    project_source_button_border_radius:               500,
    project_source_button_margin_top_bottom:           500,
    project_source_button_margin_right_left:           500,
    project_icon_copy_button_color:                    500,
    project_icon_tails_answer_question:                500,
    project_icon_tails_question_link:                  500,
    project_icon_tails_answer_link:                    500,
    Intf_CopyButtonTextColor:                          500,
    Intf_CopyButtonHoverTextColor:                     500,
    Intf_CopyButtonIconColor:                          500,
    Intf_CopiedButtonTextColor:                        500,
    Intf_CopiedButtonIconColor:                        500,
    Intf_SourceLinkButtonColorHover:                    500,
    Intf_SourceLinkButtonTextColorHover:                500,
    Intf_SourceLinkButtonBorderColorHover:               500,
  },

  customSettings: {
    Intf_CopyButtonTextColor: {
      description: 'Color of the "Copy" text in the copy button',
      default: null,
    },
    Intf_CopyButtonHoverTextColor: {
      description: 'Text color of the copy button on hover',
      default: null,
    },
    Intf_CopyButtonIconColor: {
      description: 'Color of the copy button icon',
      default: null,
    },
    Intf_CopiedButtonTextColor: {
      description: 'Text color of the copy button in the "Copied" state',
      default: null,
    },
    Intf_CopiedButtonIconColor: {
      description: 'Color of the copy button icon in the "Copied" state',
      default: null,
    },
    Intf_inputLimit: {
      description: 'Maximum number of characters allowed in the question input field',
      type: 'number',
      default: 200,
      onChange: function(value) {
        var input = document.getElementById('question-intf');
        if (input) input.maxLength = value;
      },
    },
    Intf_QuestionOnTop: {
      description: 'Controls where the chat auto-scrolls after a new answer. Default true: scrolls so the last question sits at the top. If false: scrolls to the bottom so the last answer is fully visible instead, which may leave the last question partially or fully hidden above it',
      type: 'boolean',
      default: true,
    },
    Intf_SourceLinkButtonColorHover: {
      description: 'Background color of the source button on hover',
      default: '#3074FF',
    },
    Intf_SourceLinkButtonTextColorHover: {
      description: 'Text color of the source button on hover',
      default: '#FFFFFF',
    },
    Intf_SourceLinkButtonBorderColorHover: {
      description: 'Border color of the source button on hover',
      default: '#3074FF',
    },
    Intf_IconScrollUp: {
      description: 'Color of the "scroll up" icon. Overrides the scroll-down color for this icon only; if unset, it inherits the scroll-down color',
      default: null,
    },
    Intf_IconScrollUpBackgroundColor: {
      description: 'Background color of the "scroll up" icon. Overrides the scroll-down background color for this icon only; if unset, it inherits the scroll-down background color',
      default: null,
    },
  },

  priorityById: {
    project_chat_question_title_color:    'project_chat_question_title_color',
    project_chat_question_subtitle_color: 'project_chat_question_subtitle_color',
    project_chat_question_text_color:     'project_chat_question_text_color',
    project_chat_answer_text_color:       'project_chat_answer_text_color',
    project_chat_answer_title_color:      'project_chat_answer_title_color',
    project_chat_answer_subtitle_color:   'project_chat_answer_subtitle_color',
    Intf_CopyButtonTextColor:             'Intf_CopyButtonTextColor',
    Intf_CopyButtonIconColor:             'Intf_CopyButtonIconColor',
    Intf_CopiedButtonTextColor:           'Intf_CopiedButtonTextColor',
    Intf_CopiedButtonIconColor:           'Intf_CopiedButtonIconColor',
    Intf_IconScrollUp:                    'Intf_IconScrollUp',
    Intf_IconScrollUpBackgroundColor:     'Intf_IconScrollUpBackgroundColor',
  },

  guardById: {
    project_question_answer_title_color:    new Set(['project_chat_question_title_color',    'project_chat_answer_title_color']),
    project_question_answer_subtitle_color: new Set(['project_chat_question_subtitle_color', 'project_chat_answer_subtitle_color']),
    project_question_answer_textcolor:      new Set(['project_chat_question_text_color',     'project_chat_answer_text_color']),
    project_icon_copy_button_color:         new Set(['Intf_CopyButtonTextColor',             'Intf_CopyButtonIconColor', 'Intf_CopiedButtonTextColor', 'Intf_CopiedButtonIconColor']),
    project_icon_scroll_down_color:            new Set(['Intf_IconScrollUp']),
    project_icon_scroll_down_background_color: new Set(['Intf_IconScrollUpBackgroundColor']),
  },

  fallbackById: {
    project_chat_question_title_color:    'project_question_answer_title_color',
    project_chat_answer_title_color:      'project_question_answer_title_color',
    project_chat_question_subtitle_color: 'project_question_answer_subtitle_color',
    project_chat_answer_subtitle_color:   'project_question_answer_subtitle_color',
    project_chat_question_text_color:     'project_question_answer_textcolor',
    project_chat_answer_text_color:       'project_question_answer_textcolor',
    Intf_CopyButtonTextColor:             'project_icon_copy_button_color',
    Intf_CopyButtonIconColor:             'project_icon_copy_button_color',
    Intf_CopiedButtonTextColor:           'project_icon_copy_button_color',
    Intf_CopiedButtonIconColor:           'project_icon_copy_button_color',
    Intf_IconScrollUp:                    'project_icon_scroll_down_color',
    Intf_IconScrollUpBackgroundColor:     'project_icon_scroll_down_background_color',
    project_answer_block_border_radius_bottom_right:   'project_answer_question_block_border_radius',
    project_answer_block_border_radius_bottom_left:    'project_answer_question_block_border_radius',
    project_question_block_border_radius_bottom_right: 'project_answer_question_block_border_radius',
    project_question_block_border_radius_bottom_left:  'project_answer_question_block_border_radius',
  },
};
